// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"apps_backoffice_ng-eld_src_app_pages_pages_module_ts":"3f335405e03d19d6","common":"877f9201f8bc4aeb","apps_backoffice_ng-eld_src_app_pages_resources_resources_module_ts":"9e68bbc9c4c4714e","apps_backoffice_ng-eld_src_app_pages_reports_reports_module_ts":"483cbc4efcaf5517"}[chunkId] + ".js";
};